import React, { useState, useEffect, useReducer, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import './Definition.css';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import AIPathSelect from '../AIPathSelect/AIPathSelect.js';
import { Icon } from '@ohif/ui/src/elements/Icon';
import { Tooltip } from '@ohif/ui/src/components/tooltip';
import { OverlayTrigger } from '@ohif/ui/src/components/overlayTrigger';
import { SimpleDialog } from '@ohif/ui/src/components/simpleDialog';
import { uploadFile } from '../../utils/upload.js';
import { servicesManager } from '../../App.js';
import { message, Cascader } from 'antd';
import {
  getCategory,
  getTag2,
  getPosition,
  getDisease,
  createDefinition,
} from './api';

function Definition({ item, ...props }) {
  const { onChange } = props;
  const history = useHistory();
  //类别
  const [categorys, setCategorys] = useState([]);
  const [tag1s, setTag1s] = useState([]);
  const [tag2s, setTag2s] = useState([]);
  const [sites, setSites] = useState([]);
  const [siteVal, setSiteVal] = useState([]);
  const [diseases, setDiseases] = useState([]);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isUpload, setIsUpload] = useState(false);

  const [form, dispatchForm] = useReducer(
    (state, action) => {
      if (action.type === 'all') {
        return { ...state, ...action.payload };
      }
      return { ...state, [action.type]: action.payload };
    },
    {
      dicCheckId: -1, //检测项目id
      organId: '', //检测部位id

      category: '', //类别
      target: '', //目标
      volume: '', //容量
      tag1: '', //标签1
      name: '', // 名称

      diseaseList: [], //病症列表
      site: '', //疾病部位
      diseaseLabel: '', //病症名称label
      diseaseName: [], //病症名称

      explain: {
        name: '',
        value: '',
      }, //标注说明
      example: {
        name: '',
        value: '',
      }, //标注示例
      tag2: [],
      tag2Label: '',
      remarks: '',
    }
  );

  const selectValue = (value, options) =>
    options.find(option => option.value === value);

  const selectMultiValue = (values, options) => {
    if (!values) {
      return '';
    }
    if (values.length > 0) {
      let arr = values.map(i =>
        options.find(option => option.value == i.tagId)
      );
      if (arr && arr.length > 0) return arr[0];
      return '';
    } else {
      return [];
    }
  };

  const getDiseaseLabel = values => {
    if (!values) {
      return '';
    }
    if (values.length > 0) {
      return values.map(i => i.diseaseName).toString();
    } else {
      return '';
    }
  };

  const getTag2Label = values => {
    if (!values) {
      return '';
    }
    if (values.length > 0) {
      return values.map(i => i.tagName).toString();
    } else {
      return '';
    }
  };

  // const selectGroupValue = (value, options) => {
  //   let arr = '';
  //   options.map(i =>
  //     i.options.find(option => {
  //       if (option.value === value) {
  //         arr = option;
  //       }
  //     })
  //   );
  //   return arr;
  // };

  const getSiteValue = (value, options) => {
    let arr = [];
    options.map(item => {
      if (item.value === value.organId) {
        arr.push(item.label);
      } else {
        if (item.children && item.children.length) {
          item.children.map(i => {
            if (i.value == value.organId) {
              arr.push(item.label);
              arr.push(i.label);
            }
          });
        }
      }
    });
    return arr;
  };

  const getDiseaseNameValue = (values, options) => {
    let valuesArr = JSON.parse(values);
    if (valuesArr && valuesArr.length > 0) {
      let arr = [];
      valuesArr.map(i =>
        options.find(option => {
          if (option.id == i.diseaseId) {
            arr.push(option);
          }
        })
      );
      return arr;
    }
    return [];
  };

  const getDiseaseListValue = values => {
    if (!values) return;
    if (values && values.length > 0) {
      let arr = [];
      values.map(i => {
        (i.flag = false),
          arr.push({ diseaseId: i.diseaseId, organId: i.organId });
      });
      return arr;
    }
    return '';
  };

  const handleChange = useCallback(
    type => event => dispatchForm({ type, payload: event.target.value }),
    [dispatchForm]
  );

  useEffect(() => {
    const getCategoryList = async () => {
      try {
        getCategory({ code: 'IMAGEDATATYPE' }).then(res => {
          if (res.status == 'success') {
            let list = res.list.map(i => {
              return { value: i.id, label: i.name };
            });
            setCategorys(list);
          }
        });
      } catch (error) {
        console.warn(error);
      }
    };
    const getTag1List = async () => {
      try {
        getCategory({ code: 'IMAGE_DATA_TAG_ONE' }).then(res => {
          if (res.status == 'success') {
            let list = res.list.map(i => {
              return { id: i.id, value: i.id, label: i.name };
            });
            setTag1s(list);
          }
        });
      } catch (error) {
        console.warn(error);
      }
    };

    const getPositionList = async () => {
      try {
        getPosition({ id: '108' }).then(res => {
          if (res.status == 'success') {
            let list = res.data.children;
            let newlist = list.map(item => {
              let obj = {
                label: item.name,
                options: [],

                value: item.id, //
                children: [], //
              };
              if (item.children && item.children.length > 0) {
                item.children.map(i => {
                  obj.options.push({ value: i.id, label: i.name });
                  obj.children.push({ value: i.id, label: i.name }); //
                });
              }
              return obj;
            });
            setSites(newlist);
          }
        });
      } catch (error) {
        console.warn(error);
      }
    };
    getCategoryList();
    getTag1List();
    getPositionList();
  }, []);

  useEffect(() => {
    const init = async () => {
      let organId;
      let site = [];
      let diseaseName = '';
      let tag2 = '';
      await getTag2().then(res => {
        if (res.status == 'success') {
          let list = res.list.map(i => {
            return { id: i.id, value: i.id, label: i.name };
          });
          if (list && list.length > 0) {
            setTag2s(list);
            tag2 = selectMultiValue(item.tagTwoName, list);
          }
        }
      });

      if (item.diseaseNames && item.diseaseNames.length > 0) {
        organId = item.diseaseNames[0].organId;

        site = getSiteValue(item.diseaseNames[0], sites);
        setSiteVal(organId);
        await getDisease({ organId: organId }).then(res => {
          if (res.status == 'success') {
            let list = res.list.map(i => {
              return { id: i.id, value: i.code, label: i.name };
            });
            if (list && list.length > 0) {
              setDiseases(list);
              diseaseName = getDiseaseNameValue(item.diseaseId, list);
            }
          }
        });
      }

      if (item.id) {
        setIsUpload(true);
        dispatchForm({
          type: 'all',
          payload: {
            dicCheckId: item.dicCheckId, //
            organId: item.organId,

            category: item.typeName,
            target: item.target, //目标
            volume: item.capacity, //容量
            tag1: selectValue(item.tagOne, tag1s), //标签1
            name: item.name, // 名称

            //病症部分
            // site: selectGroupValue(organId, sites), //病症部位
            site: site, //病症部位
            diseaseList: getDiseaseListValue(item.diseaseNames),
            diseaseLabel: getDiseaseLabel(item.diseaseNames), //病症名称Label
            diseaseName: diseaseName, //病症名称

            explain: {
              name: item.labelSignDto.name,
              value: item.labelSignDto.url,
            }, //标注说明
            example: {
              name: item.labelRemarkDto.name,
              value: item.labelRemarkDto.url,
            }, //标注示例
            // tag2: selectMultiValue(item.tagTwoName, tag2s), //标签2
            tag2: tag2, //标签2
            tag2Label: getTag2Label(item.tagTwoName), //标签2label
            remarks: item.imageAcquisition, //图像采集要点

            dicCheckNameError: '', //路径
            categoryError: '',
            targetError: '',
            volumeError: '',
            tag1Error: '',
            nameError: '',
            tag2Error: '',
            siteError: '',
            diseaseError: '',
            labelError: '',
            remarksError: '',
          },
        });
      } else {
        setIsUpload(false);
        dispatchForm({
          type: 'all',
          payload: {
            dicCheckId: '', //
            organId: '',

            category: '',
            target: '', //目标
            volume: '',
            tag1: '',
            name: '',
            //病症部分
            site: '', //疾病部位
            diseaseList: [],
            diseaseName: [], //病症名称

            explain: {
              name: '',
              value: '',
            }, //标注说明
            example: {
              name: '',
              value: '',
            }, //标注示例
            tag2: '',
            remarks: '',
          },
        });
      }
    };
    init();
  }, [item, sites, tag1s]);

  const styleDialog = {
    background: '#efefef',
    height: 40,
    color: '#000',
    menuListBackground: '#91B9CD',
    placeholderColor: '#000',
    padding: '0 12px',
  };

  //病症
  const customStyles = {
    indicatorSeparator: () => {
      null;
    }, // removes the "stick"
    placeholder: (provided, state) => ({
      ...provided,
      color: '#000;',
    }),
    menu: base => ({
      ...base,
      backgroundColor: '#556472',
    }),
    menuList: base => ({
      ...base,
      paddingTop: '0px',
    }),
    option: (provided, state) => ({
      ...provided,
      color: '#FFFFFF',
      backgroundColor: state.isFocused ? '#91B9CD' : '#556472',
      padding: '12px 20px',
      height: '40px',
    }),
    control: () => ({
      // none of react-select's styles are passed to <Control />
      color: '#000',
      width: '100%',
      minHeight: 40,
      alignItems: 'center',
      display: 'flex',
      backgroundColor: '#fff',
      margin: 0,
      padding: '0 12px',
      borderRadius: 6,
      flexWrap: 'inherit',
    }),
    multiValue: (styles, { data }) => {
      return {
        ...styles,
        color: '#fff',
        backgroundColor: '#556472',
      };
    },
    multiValueLabel: (styles, { data }) => ({
      ...styles,
      color: '#fff',
    }),
  };
  //病症部位
  // const groupStyles = {
  //   display: 'flex',
  //   alignItems: 'center',
  //   justifyContent: 'space-between',
  // };
  // const formatGroupLabel = data => (
  //   <div style={groupStyles}>
  //     <span>{data.label}</span>
  //   </div>
  // );

  const categoryHandleChange = async e => {
    dispatchForm({ type: 'category', payload: e });
  };

  const tag1HandleChange = async e => {
    dispatchForm({ type: 'tag1', payload: e });
  };

  const tag2HandleChange = async e => {
    dispatchForm({ type: 'tag2', payload: e });
  };

  // const siteHandleChange = async e => {
  //   dispatchForm({ type: 'site', payload: e });
  //   dispatchForm({ type: 'diseaseName', payload: '' });
  //   getDiseaseList(e.value);
  // };

  const siteHandleChang2e = async e => {
    if (e && e.length > 0) {
      setSiteVal(e[e.length - 1]);
      dispatchForm({ type: 'site', payload: e[e.length - 1] });
      dispatchForm({ type: 'diseaseName', payload: '' });
      getDiseaseList(e[e.length - 1]);
    }
  };

  const diseaseHandleChange = async e => {
    let obj = [];
    if (e && e.length) {
      e.map(i => {
        obj.push({
          // organId: form.site.value,
          // organId: form.site,
          organId: siteVal,
          diseaseId: i.__isNew__ ? i.label : i.id,
          flag: i.__isNew__ ? true : false,
        });
      });
    }
    dispatchForm({ type: 'diseaseList', payload: obj });
    dispatchForm({ type: 'diseaseName', payload: e });
  };

  //获取新的AI匹配路劲
  const newAICheckPath = async selected => {
    if (!selected) return;
    dispatchForm({ type: 'dicCheckId', payload: selected.id });
    dispatchForm({ type: 'organId', payload: selected.parentId });
  };

  //疾病
  const getDiseaseList = e => {
    try {
      getDisease({ organId: e }).then(res => {
        if (res.status == 'success') {
          let list = res.list.map(i => {
            return { id: i.id, value: i.id, label: i.name };
          });
          setDiseases(list);
        }
      });
    } catch (error) {
      console.warn(error);
    }
  };
  //新建
  const create = async () => {
    // let next =validateForm();
    // let isNew = false;
    if (validateForm()) {
      return;
    }
    let explain = {
      url: form.explain.value,
      name: form.explain.name,
    };
    let example = {
      url: form.example.value,
      name: form.example.name,
    };
    let tagTwoName = [];
    if (form.tag2.__isNew__) {
      tagTwoName.push({
        tagId: form.tag2.label,
        flag: true,
      });
    } else {
      tagTwoName.push({
        tagId: form.tag2.id ? form.tag2.id : form.tag2.tagId,
        flag: false,
      });
    }

    const payload = {
      deviceId: '1', //路径 (设备 检测路径 检测部位)
      dicCheckId: form.dicCheckId, //路径 检测路径 默认-1 显示请选择
      organId: form.organId, //路径 检测部位id

      capacity: form.volume, // 容量
      diseaseNames: form.diseaseList,
      imageAcquisition: form.remarks, //图像采集要点
      labelSignDto: explain,
      labelRemarkDto: example,

      name: form.name,
      tagOne: form.tag1.value,
      tagTwoName: tagTwoName,
      target: form.target, //目标
      type: form.category.value, //类别
    };
    // console.log(payload);
    // return;
    const { UINotificationService } = servicesManager.services;
    const result = await createDefinition(payload);
    if (result.status == 'success') {
      const message = '';
      UINotificationService.show({
        title: '添加成功',
        message,
        type: 'info',
        autoClose: true,
      });
      item.tagTwoName = tagTwoName;
      item.imageAcquisition = form.remarks;
      onChange && onChange('111', '22');
      // setRefresh(true);
    }
  };
  //修改
  const edit = async () => {
    if (validateForm()) {
      return;
    }
    let explain = {
      url: form.explain.value,
      name: form.explain.name,
    };
    let example = {
      url: form.example.value,
      name: form.example.name,
    };
    let tagTwoName = [];
    let diseaseList = [];
    if (form.tag2.__isNew__) {
      tagTwoName.push({
        tagId: form.tag2.label,
        flag: true,
      });
    } else {
      tagTwoName.push({
        tagId: form.tag2.id ? form.tag2.id : form.tag2.tagId,
        flag: false,
      });
    }

    if (form.diseaseList.length > 0) {
      diseaseList = form.diseaseList.map(i => {
        return {
          organId: i.organId,
          diseaseId: i.diseaseId,
          flag: i.flag ? true : false,
        };
      });
    }

    const payload = {
      deviceId: '1', //路径(设备 检测路径 检测部位) 默认device为CT 设备deviceId为1
      dicCheckId: form.dicCheckId, //路径
      organId: form.organId, //路径

      capacity: form.volume, // 容量
      diseaseNames: diseaseList,
      imageAcquisition: form.remarks, //图像采集要点
      // labelSign: explain,
      // lableRemark: example,
      labelSignDto: explain,
      labelRemarkDto: example,
      name: form.name,
      tagOne: form.tag1.value,
      tagTwoName: tagTwoName,
      target: form.target, //目标
      type: form.category.value, //类别
      id: item.id,
    };
    // console.log(payload);
    // return;
    const { UINotificationService } = servicesManager.services;
    const result = await createDefinition(payload);
    if (result.status == 'success') {
      const message = '';
      UINotificationService.show({
        title: '修改成功',
        message,
        type: 'info',
        autoClose: true,
      });
      item.tagTwoName = tagTwoName;
      item.imageAcquisition = form.remarks;
      onChange && onChange('111', '22');
      // setRefresh(true);
    }
  };
  //取消
  const cancl = () => {
    history.push({
      pathname: '/research',
    });
  };

  const validateForm = () => {
    let dicCheckNameError = '',
      categoryError = '',
      targetError = '',
      volumeError = '',
      tag1Error = '',
      nameError = '',
      tag2Error = '',
      siteError = '',
      diseaseError = '',
      labelError = '',
      remarksError = '';
    let isError = false;
    if (form.dicCheckId == '-1' || !form.dicCheckId) {
      dicCheckNameError = '请选择路径';
      isError = true;
    }
    if (item.opt === 2 && !form.category.value) {
      categoryError = '请选择类别';
      isError = true;
    }
    if (!form.target) {
      targetError = '请输入目标';
      isError = true;
    }
    if (!form.volume) {
      volumeError = '请输入容量';
      isError = true;
    }
    if (!form.tag1.value) {
      tag1Error = '请选择标签1';
      isError = true;
    }
    if (!form.name) {
      nameError = '请输入名称';
      isError = true;
    }
    if (!form.tag2) {
      tag2Error = '请选择或输入标签2';
      isError = true;
    }
    if (form.diseaseList < 1) {
      siteError = '请选择病症部位';
      diseaseError = '请选择病症部位';
      isError = true;
    }
    if (form.diseaseList > 1 && !form.diseaseList[0].diseaseId) {
      diseaseError = '请选择疾病';
      isError = true;
    }
    if (!form.explain.value && !form.explain.value) {
      labelError = '请上传标注文件';
      isError = true;
    }
    if (form.example.value && !form.explain.value) {
      labelError = '请上传标注说明';
      isError = true;
    }
    if (!form.example.value && form.explain.value) {
      labelError = '请上传标注示例';
      isError = true;
    }
    if (!form.remarks) {
      remarksError = '请输入图像采集要点';
      isError = true;
    }
    dispatchForm({
      type: 'all',
      payload: {
        dicCheckNameError, //路径
        categoryError,
        targetError,
        volumeError,
        tag1Error,
        nameError,
        tag2Error,
        siteError,
        diseaseError,
        labelError,
        remarksError,
      },
    });
    return isError;
  };

  const onClose = () => {
    setIsDialogOpen(false);
  };

  const onConfirm = () => {
    if (form.explain.value && form.example.value) {
      setIsDialogOpen(false);
      setIsUpload(true);
    }
  };

  const uploadExplain = e => {
    let file = e.target.files[0];
    if (file && file.type == 'application/pdf') {
      uploadFile(file, handleExplainUpload);
    } else {
      message.error(`文件类型不正确!`);
    }
  };
  const handleExplainUpload = fileInfo => {
    dispatchForm({
      type: 'explain',
      payload: { name: fileInfo.name, value: fileInfo.url },
    });
  };
  const uploadExample = e => {
    let file = e.target.files[0];
    if (file && file.type == 'application/pdf') {
      uploadFile(file, handleExampleUpload);
    } else {
      message.error(`文件类型不正确!`);
    }
  };
  const handleExampleUpload = fileInfo => {
    dispatchForm({
      type: 'example',
      payload: { name: fileInfo.name, value: fileInfo.url },
    });
  };

  return (
    <>
      <div className="definition">
        <div className="header">定义</div>
        <div className="content">
          <div className="top">
            <div
              style={{
                marginRight: '23px',
              }}
            >
              路径
            </div>
            <div>
              {item.opt === 1 ? (
                <div
                  className="label"
                  style={{
                    width: '300px',
                  }}
                >
                  {item.checkName}
                </div>
              ) : (
                <>
                  <AIPathSelect
                    callbackAICheckPath={newAICheckPath}
                    device={'CT'}
                    id={form.dicCheckId}
                    name={item.checkName}
                    isAll={'all'}
                    inDialog={true}
                    styleDialog={styleDialog}
                    width={'300px'}
                  />
                  {form.dicCheckNameError && (
                    <div className="error">{form.dicCheckNameError}</div>
                  )}
                </>
              )}
            </div>
          </div>
          <div className="center">
            <div className="cen-col">
              <div className="name">类别</div>
              <div className="value">
                {item.id ? (
                  <div className="label"> {item.typeName}</div>
                ) : (
                  <>
                    <Select
                      styles={customStyles}
                      placeholder="待定义"
                      value={form.category}
                      options={categorys}
                      id="category"
                      key="category"
                      onChange={categoryHandleChange}
                    />
                    {form.categoryError && (
                      <div className="error">{form.categoryError}</div>
                    )}
                  </>
                )}
              </div>
            </div>
            <div className="cen-col">
              <div className="name">目标</div>
              <div className="value">
                {item.opt === 1 ? (
                  <div className="label">{form.target}</div>
                ) : (
                  <>
                    <input
                      placeholder="待输入"
                      className="input"
                      type="text"
                      value={form.target}
                      onChange={handleChange('target')}
                    />
                    {form.targetError && (
                      <div className="error">{form.targetError}</div>
                    )}
                  </>
                )}
              </div>
            </div>
            <div className="cen-col">
              <div className="name">容量</div>
              <div className="value">
                {item.opt === 1 ? (
                  <div className="label">{form.volume}</div>
                ) : (
                  <>
                    <input
                      placeholder="待输入"
                      className="input"
                      type="number"
                      value={form.volume}
                      onChange={handleChange('volume')}
                    />
                    {form.volumeError && (
                      <div className="error">{form.volumeError}</div>
                    )}
                  </>
                )}
              </div>
            </div>
            <div className="cen-col">
              <div className="name">标签1</div>
              <div className="value">
                {item.opt === 1 ? (
                  <div className="label">{item.tagOneName}</div>
                ) : (
                  <>
                    <Select
                      styles={customStyles}
                      options={tag1s}
                      placeholder="待定义"
                      value={form.tag1}
                      id="tag1"
                      key="tag1"
                      onChange={tag1HandleChange}
                    />
                    {form.tag1Error && (
                      <div className="error">{form.tag1Error}</div>
                    )}
                  </>
                )}
              </div>
            </div>
            <div className="cen-col">
              <div
                className="name"
                style={{
                  flex: 'none',
                }}
              >
                名称
              </div>
              <div className="value">
                {item.opt === 1 ? (
                  <div className="label">{form.name}</div>
                ) : (
                  <>
                    <input
                      placeholder="待输入"
                      className="input"
                      type="text"
                      value={form.name}
                      onChange={handleChange('name')}
                    />
                    {form.nameError && (
                      <div className="error">{form.nameError}</div>
                    )}
                  </>
                )}
              </div>
            </div>
            <div className="cen-col">
              <div className="name">病症</div>
              <div className="value">
                {item.opt === 1 ? (
                  <div className="label">
                    {form.site.length > 0 ? form.site.join('/') : ''}
                  </div>
                ) : (
                  <>
                    <Cascader
                      options={sites}
                      defaultValue={form.site}
                      // value={form.site}
                      className="cus_cascader"
                      onChange={siteHandleChang2e}
                      placeholder="请选择脏器"
                    />
                    {form.siteError && (
                      <div className="error">{form.siteError}</div>
                    )}
                  </>
                )}
              </div>
            </div>
            <div className="cen-col">
              <div className="name">病症</div>
              <div className="value">
                {item.opt === 1 ? (
                  <OverlayTrigger
                    key={1}
                    placement="top"
                    overlay={
                      <Tooltip
                        placement="top"
                        className="in tooltip-warning"
                        id="tooltip-top"
                      >
                        <div className="warningContent">
                          {form.diseaseLabel}
                        </div>
                      </Tooltip>
                    }
                  >
                    <div className="label">{form.diseaseLabel}</div>
                  </OverlayTrigger>
                ) : (
                  <>
                    <CreatableSelect
                      styles={customStyles}
                      placeholder="待定义"
                      id="diseaseName"
                      key="diseaseName"
                      isMulti
                      onChange={diseaseHandleChange}
                      options={diseases}
                      value={form.diseaseName}
                    />
                    {form.diseaseError && (
                      <div className="error">{form.diseaseError}</div>
                    )}
                  </>
                )}
              </div>
            </div>
            {/* <div className="cen-col">
              <div className="name">标注要求</div>
              <div className="value">
                <button
                  className="upload"
                  onClick={() => setIsDialogOpen(true)}
                >
                  <span>{isUpload ? '上传完成' : '上传'}</span>
                  <Icon name="upload" />
                </button>
                {form.labelError && (
                  <div className="error">{form.labelError}</div>
                )}
              </div>
            </div> */}
            <div className="cen-col">
              <div className="name">标签2</div>
              <div className="value">
                {item.opt === 1 ? (
                  <OverlayTrigger
                    key={1}
                    placement="top"
                    overlay={
                      <Tooltip
                        placement="top"
                        className="in tooltip-warning"
                        id="tooltip-top"
                      >
                        <div className="warningContent">{form.tag2Label}</div>
                      </Tooltip>
                    }
                  >
                    <div className="label">{form.tag2Label}</div>
                  </OverlayTrigger>
                ) : (
                  <>
                    <CreatableSelect
                      styles={customStyles}
                      placeholder="待定义"
                      isClearable
                      onChange={tag2HandleChange}
                      options={tag2s}
                      id="tag2"
                      key="tag2"
                      // defaultValue={form.tag2}
                      value={form.tag2}
                    />
                    {form.tag2Error && (
                      <div className="error">{form.tag2Error}</div>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
          <div className="mark">
            <div className="upload">
              <div>标注要求：</div>
              {item.opt === 1 ? (
                <div
                  style={{
                    paddingLeft: '8px',
                  }}
                >
                  <Icon
                    style={{
                      marginBottom: '-5px',
                    }}
                    name="upload"
                  />
                  <span
                    style={{
                      paddingLeft: '8px',
                    }}
                  >
                    点击上传
                  </span>
                </div>
              ) : (
                <div
                  onClick={() => setIsDialogOpen(true)}
                  style={{
                    paddingLeft: '8px',
                    cursor: 'pointer',
                  }}
                >
                  <Icon
                    style={{
                      marginBottom: '-5px',
                    }}
                    name="upload"
                  />
                  <span
                    style={{
                      paddingLeft: '8px',
                    }}
                  >
                    点击上传
                  </span>
                </div>
              )}
            </div>
            {form.labelError && (
              <>
                <div
                  style={{
                    marginTop: '-13px',
                  }}
                  className="error"
                >
                  {form.labelError}
                </div>
              </>
            )}
            <div className="show">
              {form.explain.value && (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: '15px',
                  }}
                >
                  <Icon
                    style={{
                      color: 'red',
                      height: '20px',
                    }}
                    name="pdf"
                  />
                  <a
                    href={form.explain.value}
                    target="_blank"
                    style={{
                      marginLeft: '16px',
                    }}
                    rel="noopener noreferrer"
                  >
                    {form.explain.name}
                  </a>
                </div>
              )}
              {form.example.value && (
                <>
                  <div
                    style={{
                      marginLeft: '50px',
                      display: 'flex',
                      alignItems: 'center',
                      marginBottom: '15px',
                    }}
                  >
                    <Icon
                      style={{
                        color: 'red',
                        height: '20px',
                      }}
                      name="pdf"
                    />
                    <a
                      href={form.example.value}
                      target="_blank"
                      style={{
                        marginLeft: '16px',
                      }}
                      rel="noopener noreferrer"
                    >
                      {form.example.name}
                    </a>
                  </div>
                </>
              )}
            </div>
          </div>
          <div className="botom">
            <div>图像采集要点</div>
            <div
              style={{
                paddingRight: '25px',
              }}
            >
              {item.opt === 1 ? (
                <div className="report-textarea">{form.remarks}</div>
              ) : (
                <>
                  <textarea
                    className="report-textarea"
                    value={form.remarks}
                    onChange={handleChange('remarks')}
                  />
                  {form.remarksError && (
                    <div className="error">{form.remarksError}</div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
        <div className="footer">
          {item.opt === 1 && (
            <>
              <button
                type="button"
                onClick={history.goBack}
                className="btn btn-cancel"
              >
                关闭
              </button>
            </>
          )}
          {item.opt === 2 && (
            <>
              <button type="button" onClick={cancl} className="btn btn-cancel">
                取消
              </button>
              <button
                type="button"
                className="btn btn-confirm"
                onClick={create}
              >
                新建
              </button>
            </>
          )}
          {item.opt === 3 && (
            <>
              <button type="button" onClick={cancl} className="btn btn-cancel">
                取消
              </button>
              <button type="button" className="btn btn-confirm" onClick={edit}>
                确定
              </button>
            </>
          )}
        </div>
      </div>
      <SimpleDialog
        rootClass="definitionDialog"
        isOpen={isDialogOpen}
        headerTitle=""
        onClose={onClose}
        onConfirm={onConfirm}
      >
        <label className="simpleDialogLabelFor">标注说明</label>
        {item.opt === 1 ? null : (
          <div className="photo_upload">
            <div className="card">
              <Icon name="upload" />
              <label htmlFor="explain">点击上传</label>
            </div>
            <input
              type="file"
              accept="application/pdf"
              id="explain"
              name="explain"
              value={''}
              onChange={e => uploadExplain(e)}
            />
          </div>
        )}

        <div
          style={{
            height: '48px',
            lineHeight: '48px',
            marginBottom: '10px',
          }}
        >
          <a
            href={form.explain.value}
            target="_blank"
            className="url"
            rel="noopener noreferrer"
          >
            {form.explain.name}
          </a>
        </div>

        <label className="simpleDialogLabelFor">标注示例</label>
        {item.opt === 1 ? null : (
          <div className="photo_upload">
            <div className="card">
              <Icon name="upload" />
              <label htmlFor="example">点击上传</label>
            </div>
            <input
              type="file"
              accept="application/pdf"
              id="example"
              name="example"
              value={''}
              onChange={e => uploadExample(e)}
            />
          </div>
        )}

        <div
          style={{
            height: '48px',
            lineHeight: '48px',
            marginBottom: '10px',
          }}
        >
          <a
            href={form.example.value}
            target="_blank"
            className="url"
            rel="noopener noreferrer"
          >
            {form.example.name}
          </a>
        </div>
        <div
          style={{
            color: '#fff',
          }}
        >
          上传文件只支持pdf格式
        </div>
      </SimpleDialog>
    </>
  );
}

Definition.propTypes = {
  onChange: PropTypes.func,
  item: PropTypes.object,
};

Definition.defaultProps = {
  item: {
    opt: 2, //操作类型 1查看 2新增 3修改
    dicCheckId: -1, //路径 checkName为空时显示请选择
    checkName: '', //路径 显示名称
  },
};

export default Definition;
